import { useParams, useSearchParams } from 'react-router-dom';
import { MonthParams } from '../../types';
import { toNumber } from '@/utils/toNumber/toNumber';

export function useRouteParams() {
  const { year, month } = useParams<MonthParams>();

  const [searchParams] = useSearchParams();

  return {
    routeParams: {
      jahr: toNumber(year),
      monat: toNumber(month),
    },
    searchParams: {
      jahr: toNumber(searchParams.get('jahr')),
      monat: toNumber(searchParams.get('monat')),
    },
  };
}
